import React from 'react';
import styled from 'styled-components';
import { browserHistory } from 'react-router';

import { Select } from 'components/ui/Select';
import { getTranslatedString } from 'helpers/i18n';

const StyledSelect = styled(Select)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const StyledH2 = styled.h2`
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: ${props => (props.img ? '#f4f4f4' : '#4e4e4e')};
  font-family: 'Circular';
  text-align: left;
`;

const StyledContainer = styled.div`
  width: 350px;
`;

export default props => {
  const redirects = [
    {
      value: 'select',
      label: getTranslatedString('login.selectPortal'),
      disabled: true,
    },
    {
      value: 'resident',
      label: getTranslatedString('pageTitle.resident'),
    },
    {
      value: 'landlord',
      label: getTranslatedString('login.mgmtTeam'),
    },
    {
      value: 'maintenance',
      label: getTranslatedString('login.maintenancePortal'),
    },
  ];

  const handleRedirect = e => {
    const redirect = e.target.value;

    if (redirect === 'landlord') {
      browserHistory.push('/companies');
    } else if (redirect === 'maintenance') {
      browserHistory.push('/maintenance');
    } else {
      browserHistory.push('/');
    }
    window.location.reload();
  };

  return (
    <StyledContainer>
      <StyledH2 img={props.img}>{getTranslatedString('login.redirect')}</StyledH2>
      <StyledSelect
        options={redirects}
        name="subset"
        value="select"
        placeholder={getTranslatedString('login.selectPortal')}
        onChange={handleRedirect}
        disabled={props.isAuthenticating}
      />
    </StyledContainer>
  );
};
